import { Injectable } from '@angular/core';
import { UserArgs } from '@intercom/messenger-js-sdk/dist/types';
import { NGXLogger } from 'ngx-logger';
import { BundleInfoService } from './bundle-info.service';
import { GoogleTagManagerService } from './google-tag-manager.service';
import { IntercomService } from './intercom.service';
import { SoldoCookieService } from './soldo-cookie.service';

@Injectable()
export class IntercomIntegrationService {
    private initialized = false;
    private applicantFirstName: string;
    private applicantLastName: string;
    private salesforceExternalId: string;

    constructor(
        private readonly logger: NGXLogger,
        private readonly intercom: IntercomService,
        private readonly cookieService: SoldoCookieService,
        private readonly gtmService: GoogleTagManagerService,
        private readonly bundleInfoService: BundleInfoService
    ) {}

    init() {
        if (!this.initialized) {
            this.intercom.start();
            this.initialized = true;
        }
    }

    onNavigationEnd() {
        this.gtmService.requestGoogleClientID().then((clientId) => {
            if (this.initialized) {
                this.updateIntercomProfile(clientId);
            }
        });
    }

    setApplicantName(firstName: string, lastName: string) {
        this.applicantFirstName = firstName;
        this.applicantLastName = lastName;
    }

    setSalesforceExternalId(id: string) {
        this.salesforceExternalId = id;
    }

    private updateIntercomProfile(clientId: string) {
        const adwordsData = this.cookieService.readDedicatedGoogleClickIDCookie();
        const marketingParams = this.cookieService.readDedicatedUTMCookie();

        const userData: UserArgs = {
            "Soldo Registration ID": this.salesforceExternalId,
            "Google Client ID": clientId
        };

        if (adwordsData) {
            userData["Google Click ID"] = adwordsData.gclid;
            userData["Google Click Timestamp"] = adwordsData.gclidTimestamp;
        }
        if (marketingParams) {
            userData.utm_campaign = marketingParams.utm_campaign;
            userData.utm_content = marketingParams.utm_content;
            userData.utm_medium = marketingParams.utm_medium;
            userData.utm_source = marketingParams.utm_source;
            userData.utm_term = marketingParams.utm_term;
        }
        if (this.applicantFirstName) {
            userData.name = `${this.applicantFirstName} ${this.applicantLastName}`;
            userData["First name"] = this.applicantFirstName;
            userData["Surname"] = this.applicantLastName;
        }

        userData["Plan"] = this.bundleInfoService.getCurrentApplicationPlan();
        userData["Offer"] = this.bundleInfoService.getCurrentApplicationOffer();

        this.logger.debug("Logging in", userData);

        this.intercom.update(userData);
    }

}
